/*
 * TC 메인 히어로 — Swiper 초기화
 * 각 .tc-main-hero-swiper 를 스코프별로 초기화(페이지네이션/화살표는 내부 요소 참조).
 * Swiper 전역이 준비될 때까지 대기, 에디터 섹션 리로드 시 재초기화.
 */
(function () {
  function initOne(el) {
    if (el.dataset.swiperInit === '1') return;
    el.dataset.swiperInit = '1';

    var autoplay = el.dataset.autoplay === 'true';
    var loop = el.dataset.loop === 'true';
    var delay = (parseInt(el.dataset.speed, 10) || 5) * 1000;

    new Swiper(el, {
      loop: loop,
      speed: 600,
      autoplay: autoplay ? { delay: delay, disableOnInteraction: false } : false,
      pagination: {
        el: el.querySelector('.tc-mh-pagination'),
        clickable: true,
      },
      navigation: {
        prevEl: el.querySelector('.tc-mh-prev-btn'),
        nextEl: el.querySelector('.tc-mh-next-btn'),
      },
    });
  }

  function initAll() {
    document.querySelectorAll('.tc-main-hero-swiper').forEach(initOne);
  }

  function ready() {
    // Swiper 번들이 아직 로드 전이면 잠깐 대기 후 재시도
    if (typeof Swiper === 'undefined') {
      setTimeout(ready, 50);
      return;
    }
    initAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  // 테마 에디터: 섹션 다시 그릴 때 재초기화
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target || document;
    var el = root.querySelector ? root.querySelector('.tc-main-hero-swiper') : null;
    if (el) {
      el.dataset.swiperInit = '';
      ready();
    }
  });
})();
